import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  SEARCH_REQUEST,
  TRIP_DETIALS_URL
} from '../models/constants/search-config.constant';
import { FeatureFlagFacade } from './feature-flag.facade';
import { SearchRequest } from '@com-delta-idp/mnx-trip-management-shared-ui';
@Injectable({
  providedIn: 'root'
})
export class SearchFacade {
  constructor(public flag: FeatureFlagFacade) {}

  getSearchFlag(): Observable<boolean> {
    return this.flag.getFlag().pipe(
      map((response) => response.flags.pnrSearch),
      catchError(() => of(false))
    );
  }

  findTrip(request: SearchRequest): void {
    sessionStorage.setItem(SEARCH_REQUEST, JSON.stringify(request));
    window.location.href = TRIP_DETIALS_URL;
  }

  getListSearchFlag = (): Observable<boolean> =>
    this.flag.getFlag().pipe(
      map((response) => response.flags.pnrListSearch),
      catchError(() => of(false))
    );
}
